var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenderMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b47f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 5.81538,
    x2: 35.4087,
    xlinkHref: "#a",
    y1: 20.4749,
    y2: -12.3023
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 15.7192,
    x2: 30.9932,
    xlinkHref: "#a",
    y1: 9.34191,
    y2: -7.57539
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 14c0 4.28-3.47 7.75-7.75 7.75s-7.75-3.47-7.75-7.75 3.47-7.75 7.75-7.75c1.87 0 3.58.66 4.92 1.77h.01c.39.32.74.67 1.05 1.06 1.11 1.34 1.77 3.05 1.77 4.92z",
    fill: "url(#b)",
    opacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.75 2.75v6.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-4.69l-4.52 4.52c-.31-.39-.66-.74-1.05-1.06l4.51-4.52h-4.69c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6.5c.1 0 .19.02.29.06.18.07.33.22.4.4.04.1.06.19.06.29z",
    fill: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderMale);
export default __webpack_public_path__ + "static/media/gender-male.ade35f2bc25a7e9d38d195ee377ea8d5.svg";
export { ForwardRef as ReactComponent };